<template>
   <div class="gens-universe">
       
       <div class="title-categoary" v-if="isCategory">
           {{categoryName}}
       </div>
       <div class="gens-info">
           <!-- 5个一组 start-->
           <div class="gens-info-item" @click="jumpGensDetail('gensone')" v-if="isCategory==false||(isCategory&&(categoryName=='传染病'||categoryName=='傳染病'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190927-feature-measles.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_1')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_1')}}
               </div>
               <div class="gens-info-item-time">27 September, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('genstwo')" v-if="(isCategory==false)||(isCategory&&(categoryName=='癌症'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190730-feature-ctdna.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_2')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_2')}}
               </div>
               <div class="gens-info-item-time">30 July, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensthree')" v-if="(isCategory==false)||(isCategory&&(categoryName=='致敏原'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190725-feature-infant-food-allergy.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_3')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_3')}}
               </div>
               <div class="gens-info-item-time">25 July, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensfour')"  v-if="isCategory==false||(isCategory&&(categoryName=='生育健康'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190405-feature-pic.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_4')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_4')}}
               </div>
               <div class="gens-info-item-time">05 April, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensfive')"  v-if="isCategory==false||(isCategory&&(categoryName=='生育健康'||categoryName=='親子鑒定'||categoryName=='亲子鉴定'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190329-feature-twins.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_5')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                 {{$t('GensUniverseText.gens_content_5')}}
               </div>
               <div class="gens-info-item-time">29 March, 2019</div>
               
           </div>
           <!-- 5个一组 end-->
           <!-- 5个一组 start-->
           <div class="gens-info-item" @click="jumpGensDetail('genssix')" v-if="isCategory==false||(isCategory&&(categoryName=='無創產前檢測'||categoryName=='无创产前检测'||categoryName=='生育健康'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190315-feature-pic.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_6')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                  {{$t('GensUniverseText.gens_content_6')}}
               </div>
               <div class="gens-info-item-time">15 March, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensseven')" v-if="(isCategory==false)||(isCategory&&(categoryName=='癌症'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/180919-feature-dr-chua.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_7')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_7')}}
               </div>
               <div class="gens-info-item-time">19 September, 2018</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('genseight')" v-if="isCategory==false||(isCategory&&(categoryName=='传染病'||categoryName=='傳染病'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/190118-feature-vaccine.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_8')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_8')}}
               </div>
               <div class="gens-info-item-time">18 January, 2019</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensnine')" v-if="isCategory==false||(isCategory&&(categoryName=='天賦基因'||categoryName=='天赋基因'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/181221-feature-talent.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_9')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_9')}}
               </div>
               <div class="gens-info-item-time">21 December, 2018</div>
               
           </div>
           <div class="gens-info-item" @click="jumpGensDetail('gensten')" v-if="(isCategory==false)||(isCategory&&(categoryName=='癌症'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/181002-feature-breast-cancer.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_10')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_10')}}
               </div>
               <div class="gens-info-item-time">02 October, 2018</div>
               
           </div>
           <!-- 5个一组 end-->

           <!-- 点击加载后 需要加载的数据 start -->
           <div class="gens-info-item" @click="jumpGensDetail('genseleven')" v-if="(isCategory==false&&showmore)||(isCategory&&(categoryName=='無創產前檢測'||categoryName=='无创产前检测'||categoryName=='生育健康'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/170903-feature-down-syndrome.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_11')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                  {{$t('GensUniverseText.gens_content_11')}}
               </div>
               <div class="gens-info-item-time">03 September, 2017</div>
               
           </div>
           <div class="gens-info-item"  @click="jumpGensDetail('genstwelve')" v-if="(isCategory==false&&showmore)||(isCategory&&(categoryName=='遺傳病'||categoryName=='遗传病'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/180605-feature-dr-lam-tak-sum.jpg"/>
               <div class="gens-info-item-tip">
                   {{$t('GensUniverseText.gens_tip_12')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_12')}}
               </div>
               <div class="gens-info-item-time">05 June, 2018</div>
               
           </div>
           <div class="gens-info-item"  @click="jumpGensDetail('gensthirteen')" v-if="(isCategory==false&&showmore)||(isCategory&&(categoryName=='癌症'))">
               <img class="gens-info-item-img" src="../assets/images/gensunicerse/170810-feature-plasma-dna-Screening.jpg"/>
               <div class="gens-info-item-tip">
                  {{$t('GensUniverseText.gens_tip_13')}}
               </div>
               <div class="gens-info-item-conten-abstract">
                   {{$t('GensUniverseText.gens_content_13')}}
               </div>
               <div class="gens-info-item-time">11 August, 2017</div>
               
           </div>
           <!-- 点击加载后 需要加载的数据 end -->

         
       </div>
        
   </div>
</template>
<script>
export default {
    data(){
        return{
            showmore:false,
            categoryName:'',
            isCategory:false,
        }
    },
    mounted(){
        if(this.$route!=undefined&&this.$route.query!=undefined){
            this.categoryName=this.$route.query.categoryName==null||this.$route.query.categoryName==undefined||this.$route.query.categoryName==''?'':this.$route.query.categoryName;
            this.isCategory=this.$route.query.isCategory==null||this.$route.query.isCategory==undefined||this.$route.query.isCategory==''?false:this.$route.query.isCategory==1?true:false;
            console.log(this.categoryName,this.isCategory);
        }
    },
    methods:{
        jumpGensDetail(path){

            this.$router.push({
                path: path
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.gens-universe{
    width: 72%;
    position: relative;
    margin:auto;
    margin-top:2rem;
    text-align: center;
    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .title-categoary{

        font-size: 17px;
        line-height: 1.304347826086957em;
        color: #368da7;
        text-align: left;
        font-weight: 600;
        margin-bottom:45px;
    }
    .gens-info{
        padding:25px 15px 25px -10px !important;
        display: flex;
        justify-content:left;
        flex-wrap: wrap;
        align-items: center;
        .gens-info-item{
            margin-left:25px;
            cursor: pointer;
            background-color: #f4fcff;
            padding-bottom:15px;
            margin-bottom:25px;
            flex-basis: 26.7%;
            width:26.7%;
            display: block;
            .gens-info-item-img{
                position: relative;
                width: 100%;
                display: block;
            }
            .gens-info-item-tip{
                text-align: left;
                padding-left:10px;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
                color:#368da7;
                margin-top:10px;
                height: 50px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-bottom: 10px;
            }
            .gens-info-item-conten-abstract{
                text-align: left;
                padding:0 10px 0 10px ;
                color: #3a3a3a;
                font-size: 16px;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                height: 96px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;
            }
            .gens-info-item-time{
                padding-left:10px;
                text-align: left;
                font-weight: 500;
                color:#3a3a3a;
                line-height: 27px;
                font-size:16px;
            }
        }

    }

    .more-content{
        margin-bottom:25px;
        .show-more{
            border-color: #368da7;
            background-color: #368da7;
            color:#fff;
            font-size: 14px;
            line-height: 36px;
            height: 36px;
            font-style: normal;
            font-weight: 400;
            border-radius: 5px;
            -moz-border-radius: 5px;
            -webkit-border-radius: 5px;
            letter-spacing: 0;
            text-transform: none;
            border-width: 2px;
            border:solid 1px #368da7;
            padding:10px 20px;
            cursor: pointer;
        }
        .show-more:hover{
            background-color: #51cedd !important;
            border: solid 1px #51cedd !important;
        }
    }
     
           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversecate.vue